import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

// Bootstrap components
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";

// Custom Styles
import "../scss/pages/research.styles.scss";

// Axios
import axios from "axios";

// Assets
import CourseMedia from "../assets/img/course-media.jpg";
import { resolveStrapiMediaUrl } from "../utils/strapiMedia";

function Research() {
  const [researchData, setResearchData] = useState([]);
  const [researchGroupsData, setResearchGroupsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState({ error: false, message: "" });
  const [showModal, setShowModal] = useState(false);
  const [activeImageIndex, setActiveImageIndex] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/graphql`,
          {
            query: `
            {
              investigacionInnovacion{
                data{
                  attributes{
                    Titulo
                    Parrafo
                    TituloCuerposAcademicos
                    ParrafoCuerposAcademicos
                    Galeria {
                      data {
                        attributes {
                          url
                        }
                      }
                    }
                  }
                }
              }
            }
          `,
          },
        );
        setResearchData(
          response.data.data.investigacionInnovacion.data.attributes,
        );
      } catch (error) {
        console.error("Error fetching data:", error);
        setError({ error: true, message: error.message || error.toString() });
      } finally {
        setLoading(false);
      }
      // console.log(response.data.data);
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/graphql`,
          {
            query: `
            {
              cuerposAcademicos{
                data {
                  id      
                  attributes{
                  miembros
                  codigo   
                  posicion     
                    Informacion{
                      Titulo
                      Descripcion1
                      imagen{
                        data{
                          attributes{
                            url
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          `,
          },
        );
        const sortedResearchGroups = [
          ...response.data.data.cuerposAcademicos.data,
        ].sort(
          (a, b) =>
            (a.attributes?.posicion ?? 0) - (b.attributes?.posicion ?? 0),
        );
        setResearchGroupsData(sortedResearchGroups);
      } catch (error) {
        console.error("Error fetching data:", error);
        setError({ error: true, message: error.message || error.toString() });
      } finally {
        setLoading(false);
      }
      // console.log(response.data.data);
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <section className="loading">
        <Container>
          <h6>Cargando información...</h6>
        </Container>
      </section>
    );
  }
  if (error.error) {
    return (
      <section className="loading">
        <Container>
          <h6>No se pudo cargar la información en este momento ⌛️</h6>
        </Container>
      </section>
    );
  }

  return (
    <>
      <section className="jumbotron--informative">
        <h2>{researchData.Titulo}</h2>
        <p>{researchData.Parrafo}</p>
      </section>
      <section className="research">
        <Container fluid>
          <div className="research__heading">
            <div className="spacer--red"></div>
            <h5>{researchData.TituloCuerposAcademicos}</h5>
            <p>{researchData.ParrafoCuerposAcademicos}</p>
          </div>
          <div className="research__list">
            <div className="research__list__featured-row row">
              {researchGroupsData
                .filter((item) => item.attributes?.posicion === 1)
                .map(({ id, attributes }) => (
                  <div
                    key={id || "featured"}
                    className="research__list__item research__list__item--featured col-10 col-lg-10 offset-1"
                  >
                    <div className="research__list__item__media">
                      <img
                        src={
                          attributes.Informacion.imagen?.data?.attributes?.url
                            ? `${attributes.Informacion.imagen.data.attributes.url}`
                            : ""
                        }
                        alt={
                          attributes.Informacion.Titulo || "Cuerpo académico"
                        }
                      />
                    </div>
                    <div className="research__list__item__body">
                      <h6>{attributes.Informacion.Titulo}</h6>
                      {attributes.codigo && (
                        <span className="codigo-pill">{attributes.codigo}</span>
                      )}
                      {Array.isArray(attributes.Informacion.Descripcion1) ? (
                        attributes.Informacion.Descripcion1.map(
                          (block, idx) => {
                            if (block?.type === "paragraph") {
                              const text = (block.children || [])
                                .map((child) => child?.text || "")
                                .join("");
                              return <p key={idx}>{text}</p>;
                            }
                            return null;
                          },
                        )
                      ) : (
                        <p>{attributes.Informacion.Descripcion || ""}</p>
                      )}
                    </div>
                  </div>
                ))}
            </div>
            <div className="research__connections">
              <div className="research__children row justify-content-center">
                {researchGroupsData
                  .filter((item) => item.attributes?.posicion !== 1)
                  .map(({ id, attributes }, key) => (
                    <div
                      key={id || key}
                      className="research__list__item col-12 col-md-6 col-lg-4 mt-4"
                    >
                      <div className="research__list__item__media">
                        <img
                          src={
                            attributes.Informacion.imagen?.data?.attributes?.url
                              ? `${attributes.Informacion.imagen.data.attributes.url}`
                              : ""
                          }
                          alt={
                            attributes.Informacion.Titulo || "Cuerpo académico"
                          }
                        />
                      </div>
                      <div className="research__list__item__body">
                        {attributes.codigo && (
                          <span className="codigo-pill">
                            {attributes.codigo}
                          </span>
                        )}
                        <h6>{attributes.Informacion.Titulo}</h6>

                        {Array.isArray(attributes.Informacion.Descripcion1) ? (
                          attributes.Informacion.Descripcion1.map(
                            (block, idx) => {
                              if (block?.type === "paragraph") {
                                const text = (block.children || [])
                                  .map((child) => child?.text || "")
                                  .join("");
                                return <p key={idx}>{text}</p>;
                              }
                              return null;
                            },
                          )
                        ) : (
                          <p>{attributes.Informacion.Descripcion || ""}</p>
                        )}
                        {attributes.miembros && (
                          <div className="members">
                            <h6>Miembros</h6>
                            <div className="members__list">
                              {attributes.miembros
                                .split("\n")
                                .map((member, idx) => (
                                  <p key={idx}>{member}</p>
                                ))}
                            </div>
                          </div>
                        )}
                        {attributes.posicion === 3 && (
                          <button
                            className="btn-research-groups w-100"
                            onClick={() => setShowModal(true)}
                          >
                            Ver Grupos de Investigación
                          </button>
                        )}
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </Container>
      </section>
      {researchData.Galeria?.data?.length > 0 && (
        <section className="image-gallery">
          <Container>
            <div className="image-gallery__heading">
              <div className="spacer--red"></div>
              <h5>Galería</h5>
            </div>
            <div className="image-gallery__grid">
              {researchData.Galeria.data.map(({ attributes }, idx) => {
                const src =
                  resolveStrapiMediaUrl(attributes?.url) ?? CourseMedia;
                return (
                  <button
                    type="button"
                    key={attributes?.url ?? idx}
                    className="image-gallery__item"
                    onClick={() => setActiveImageIndex(idx)}
                    aria-label={`Ver imagen ${idx + 1} de la galería`}
                  >
                    <img src={src} alt={`Galería ${idx + 1}`} loading="lazy" />
                  </button>
                );
              })}
            </div>
          </Container>
        </section>
      )}
      <Modal
        show={activeImageIndex !== null}
        onHide={() => setActiveImageIndex(null)}
        centered
        size="lg"
        className="image-gallery-lightbox"
      >
        <Modal.Header closeButton />
        <Modal.Body>
          {activeImageIndex !== null && (
            <img
              src={
                resolveStrapiMediaUrl(
                  researchData.Galeria.data[activeImageIndex].attributes?.url,
                ) ?? CourseMedia
              }
              alt={`Galería ${activeImageIndex + 1}`}
              className="image-gallery-lightbox__image"
            />
          )}
        </Modal.Body>
      </Modal>
      <Modal show={showModal} onHide={() => setShowModal(false)} size="xl">
        <Modal.Header closeButton>
          <Modal.Title>Grupos de Investigación</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {researchGroupsData
            .filter(
              (item) =>
                item.attributes?.posicion !== 1 &&
                item.attributes?.posicion !== 2 &&
                item.attributes?.posicion !== 3 &&
                item.attributes?.posicion !== 4,
            )
            .map(({ id, attributes }) => (
              <div key={id} className="modal-research-group">
                <div className="modal-research-group__image">
                  <img
                    src={
                      attributes.Informacion.imagen?.data?.attributes?.url
                        ? `${attributes.Informacion.imagen.data.attributes.url}`
                        : ""
                    }
                    alt={
                      attributes.Informacion.Titulo || "Grupo de investigación"
                    }
                  />
                </div>
                <div className="modal-research-group__content">
                  <h5>{attributes.Informacion.Titulo}</h5>
                  {attributes.codigo && (
                    <span className="codigo-pill">{attributes.codigo}</span>
                  )}
                  {Array.isArray(attributes.Informacion.Descripcion1) ? (
                    attributes.Informacion.Descripcion1.map((block, idx) => {
                      if (block?.type === "paragraph") {
                        const text = (block.children || [])
                          .map((child) => child?.text || "")
                          .join("");
                        return <p key={idx}>{text}</p>;
                      }
                      return null;
                    })
                  ) : (
                    <p>{attributes.Informacion.Descripcion || ""}</p>
                  )}
                  {attributes.miembros && (
                    <div className="members">
                      <h6>Miembros</h6>
                      <div className="members__list">
                        {attributes.miembros.split("\n").map((member, idx) => (
                          <p key={idx}>{member}</p>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ))}
        </Modal.Body>
      </Modal>
    </>
  );
}

export default Research;
